// src/pages/Appli/AppliAdmin/Prospects/components/ProspectsTable.jsx
import React from "react";
import ButtonEdit from "../../../../../components/Button/ButtonEdit";
import ButtonDelete from "../../../../../components/Button/ButtonDelete";

function Th({ children }) {
  return <th className="py-3 px-4 text-left text-slate-600 dark:text-slate-300">{children}</th>;
}
function Td({ children, className = "" }) {
  return <td className={`py-3 px-4 align-top ${className}`}>{children}</td>;
}

export function ProspectsTable({ data, onEdit, onDelete, renderStatut }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead className="bg-slate-50 dark:bg-slate-800/60">
          <tr>
            <Th>Nom</Th>
            <Th>Association</Th>
            <Th>Fonction</Th>
            <Th>Téléphone</Th>
            <Th>Email</Th>
            <Th>Provenance</Th>
            <Th>Intérêt</Th>
            <Th>Contact</Th>
            <Th>Statut</Th>
            <Th>Actions</Th>
          </tr>
        </thead>
        <tbody>
          {data.map((p) => (
            <tr key={p.id} className="border-b border-slate-100 dark:border-slate-800">
              <Td className="font-medium">{p.nom} {p.prenom}</Td>
              <Td>{p.association?.nom_asso || p.Association?.nom_asso || "—"}</Td>
              <Td>{p.fonction || "—"}</Td>
              <Td>{p.telephone || "—"}</Td>
              <Td>{p.email || "—"}</Td>
              <Td className="capitalize">{p.provenance || "—"}</Td>
              <Td>{p.interet_produit?.nom_app || "—"}</Td>
              <Td>
                {p.date_contact ? new Date(p.date_contact).toLocaleDateString("fr-FR") : "—"}
              </Td>
              <Td>{renderStatut(p)}</Td>
              <Td>
                <div className="flex gap-2">
                  <ButtonEdit onClick={() => onEdit(p)} />
                  <ButtonDelete onClick={() => onDelete(p.id)} />
                </div>
              </Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
